import { render, staticRenderFns } from "./CloseTradeChart.vue?vue&type=template&id=736aa595"
import script from "./CloseTradeChart.vue?vue&type=script&lang=js"
export * from "./CloseTradeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports